import { ApiValidation, ValidationResult } from '../types';

export async function validateField(
  fieldName: string,
  fieldValue: string,
  apiValidation: ApiValidation,
): Promise<string> {
  const contextValues = {
    ...apiValidation.form.getValues(),
  };

  const payload = {
    field_name: fieldName,
    field_value: fieldValue,
    context: contextValues,
  };

  const response = await apiValidation.workloadClient.apiFetch(
    'workloads/validation',
    'POST',
    payload,
  );
  const data: ValidationResult = await response.json();
  let successMessage = '';
  if (response.status === 200) {
    if (data.successes.length > 0) {
      data.successes.forEach(success => {
        if (success.reasons?.length > 0) {
          success.reasons.forEach(reason => (successMessage += `${reason}. `));
        }
      });
      return successMessage;
    }
  }
  if (response.status === 400) {
    let errorMessage = '';
    if (data.failures.length > 0) {
      data.failures.forEach(failure => {
        failure.reasons.forEach(reason => (errorMessage += `${reason}. `));
      });
      return errorMessage;
    }
  } else if (response.status >= 400) {
    return 'An error occurred calling the validation API';
  }

  return '';
}
